import { render, staticRenderFns } from "./MatrixTable.vue?vue&type=template&id=00852a0d"
import script from "./MatrixTable.vue?vue&type=script&lang=js"
export * from "./MatrixTable.vue?vue&type=script&lang=js"
import style0 from "./MatrixTable.vue?vue&type=style&index=0&id=00852a0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports